import { css } from 'styled-components'

export const GIANT = 'giant'
export const DESKTOP = 'desktop'
export const PHONE = 'phone'
export const TABLET = 'tablet'
export const PHONE_DOUBLE_ZOOM = 'phone-double-zoom'

export type Device =
  | typeof PHONE
  | typeof DESKTOP
  | typeof TABLET
  | typeof GIANT
  | typeof PHONE_DOUBLE_ZOOM

type MediaFuncs = { [k in Device]: (...args: any[]) => {} }

type DeviceSizes = { [k in Device]: number }

export const sizes: DeviceSizes = {
  [PHONE_DOUBLE_ZOOM]: 400,
  [PHONE]: 656,
  [DESKTOP]: 889,
  [TABLET]: 798,
  [GIANT]: 1200,
}

export const sizeToEm = (device: Device): string => `${sizes[device] / 16}em`

const devices: Device[] = [PHONE, DESKTOP, GIANT, TABLET, PHONE_DOUBLE_ZOOM]

export default devices.reduce<MediaFuncs>((accumulator: MediaFuncs, label: Device) => {
  return {
    ...accumulator,
    [label]: (...args: any[]) => {
      const [first, ...rest] = args
      return css`
        @media (max-width: ${sizeToEm(label)}) {
          ${css(first, ...rest)};
        }
      `
    },
  }
}, {} as MediaFuncs)



// WEBPACK FOOTER //
// ./src/styled/media.ts